exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n#inputLongText,\n#inputLongPlainText {\n  height: 85px;\n}\n", "", {"version":3,"sources":["D:/a/1/RTPS-CopayePA-Portal/src/components/VOfferSegmentItem.vue"],"names":[],"mappings":";AACA;;EAEE,aAAa;CACd","file":"VOfferSegmentItem.vue","sourcesContent":["\n#inputLongText,\n#inputLongPlainText {\n  height: 85px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-174f4732","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/VOfferSegmentItem.vue
// module id = 9Rr6
// module chunks = 1